import React from 'react';
import './SocialLoading.css';

export default function SocialLoading({ label = '読み込み中…' }) {
  return <div className="social-loading" role="status">
    <span className="social-loading__spinner" aria-hidden="true" />
    <span className="social-loading__label">{label}</span>
  </div>;
}
